import { OChainId, TChainId } from '../chainIDs';

export const SUPPORTED_CHAINS: Partial<TChainId>[] = [
  OChainId.ethereum,
  OChainId.sonic,
];
